import { cmsLandingPageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-landing-page-route-path';
import { cmsSimplePageRoutePath } from '@bcf-v2/routes-statics/common/app/paths/cms-simple-page-route-path';
import { promotionsRoutePath } from '@bcf-v2/routes-statics/common/app/paths/promotions-route-path';
import { supportRoutePath } from '@bcf-v2/routes-statics/common/app/paths/support-route-path';
import { betOnActionRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/bet-on-action-route-path';
import { bpBetBuilderRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/bp-bet-builder-route-path';
import { esportRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/esport-route-path';
import { liveBettingRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/live-betting-route-path';
import { playerBetsRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/player-bets-paths';
import { preMatchesRoutePath } from '@bcf-v2/routes/sportsbook/app/paths/pre-matches-route-path';
import { FooterLink } from '../types';

export const footerLinksFn = (): FooterLink[][] => [
  [
    {
      url: cmsSimplePageRoutePath('about-us'),
      title: $localize`About us`
    },
    {
      url: 'https://lvbetpartners.com/',
      title: $localize`Affiliates`
    },
    {
      url: 'https://lvbet.lv/sports-blog/',
      title: $localize`Sports Blog`
    }
  ],
  [
    {
      url: preMatchesRoutePath(),
      title: $localize`Sports`
    },
    {
      url: liveBettingRoutePath(),
      title: $localize`Live betting`
    },
    {
      url: esportRoutePath(),
      title: $localize`Esport`
    },
    {
      url: promotionsRoutePath(),
      title: $localize`Bonuses`
    },
    {
      url: 'https://sports-stats.lvbet.lv/lv/soccer/events',
      title: $localize`Statistics`
    }
  ],
  [
    {
      url: bpBetBuilderRoutePath(),
      title: $localize`Betbuilder`
    },
    // {
    //   url: virtualSportsRoutePath(),
    //   title: $localize`Virtual sports`
    // },
    {
      url: playerBetsRoutePath(),
      title: $localize`Player Bets`,
      bottomSheetKind: 'dst-player-bets'
    },
    {
      url: betOnActionRoutePath(),
      title: 'LV Jackpot'
    },
    {
      url: cmsLandingPageRoutePath('mobile-application'),
      title: $localize`Mobile application`
    },
    {
      url: cmsLandingPageRoutePath('cash-out'),
      title: $localize`Cashout`
    },
    {
      url: cmsLandingPageRoutePath('vip-club'),
      title: $localize`Vip Club`
    }
  ],
  [
    {
      url: supportRoutePath(),
      title: $localize`Support`
    },
    {
      url: cmsSimplePageRoutePath('terms-and-conditions'),
      title: $localize`Terms and conditions`
    },
    {
      url: cmsSimplePageRoutePath('responsible-gaming'),
      title: $localize`Responsible gaming`
    },
    {
      url: cmsSimplePageRoutePath('privacy-policy'),
      title: $localize`Privacy Policy`
    },
    {
      url: cmsSimplePageRoutePath('cookies-policy'),
      title: $localize`Cookies Policy`
    },
    {
      url: cmsSimplePageRoutePath('sitemap'),
      title: $localize`Sitemap`
    }
  ]
];
